var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeHomeKnowMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.558671 1.92021C0.594414 1.63769 0.700389 1.36686 0.868155 1.12929C1.03592 0.891714 1.26084 0.693969 1.525 0.5518C1.78916 0.409631 2.08526 0.326966 2.38972 0.310391C2.69417 0.293816 2.99857 0.343788 3.27867 0.456327C4.69467 1.02099 7.868 2.36298 11.8947 4.53083C15.9227 6.69991 18.756 8.59413 19.9867 9.45356C21.0373 10.1886 21.04 11.6463 19.988 12.3838C18.7693 13.2383 15.9707 15.1076 11.8947 17.3041C7.81467 19.5005 4.67867 20.8263 3.276 21.3835C2.068 21.8649 0.716004 21.1348 0.558671 19.9196C0.374671 18.4993 0.0306702 15.2743 0.0306702 10.9187C0.0306702 6.56559 0.373337 3.34181 0.558671 1.92021Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeHomeKnowMoreIcon);
export default __webpack_public_path__ + "static/media/office-home-know-more-icon.7fd7fcc1447dd93149625b3e6c01f005.svg";
export { ForwardRef as ReactComponent };